import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Apache Junction, AZ?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk near Apache Junction can take 2–4 months. For snowbirds with departure dates set by lease agreements and seasonal schedules, that timeline is simply not viable.",
  },
  {
    q: "Can snowbirds heading back to Canada renew a passport quickly?",
    a: "Absolutely. Snowbird renewals are one of our most common request types from the Apache Junction area. If you discover your U.S. passport has expired during your summer in Canada, or you realize before your October departure that it is close to expiring, we can process an expedited renewal in as little as 2–9 business days. Start as soon as you identify the issue — do not wait until your departure week.",
  },
  {
    q: "Do I need a passport for a Rocky Point or Baja trip from Apache Junction?",
    a: "For land border crossings to Mexico, U.S. citizens technically need only a Passport Card or Enhanced Driver's License. However, if you plan any possibility of flying home from Mexico, or if you will be in remote coastal areas far from the border, a full passport book is strongly recommended. A Passport Card cannot be used for international air travel. We can process expedited applications for both passport books and passport cards.",
  },
  {
    q: "How far is the nearest passport agency from Apache Junction?",
    a: "The Phoenix Passport Agency is located at 2901 N Central Ave, Suite 1225, Phoenix, AZ 85012 — approximately 35 miles from Apache Junction via US-60. Getting an appointment there requires documented urgent travel and the appointment system is frequently unavailable for weeks. Fast Passport Center bypasses this entirely — start online, ship overnight, and we handle submission through our reserved courier access.",
  },
  {
    q: "What if I need a passport card instead of a book?",
    a: "We can process expedited applications for passport cards as well as passport books. If you primarily use a land border crossing to Mexico and do not plan to fly internationally, a passport card may be sufficient. However, we recommend a full passport book for flexibility — especially if you travel internationally by air or plan extended stays outside the U.S.",
  },
  {
    q: "Can retirees in Gold Canyon or Queen Valley use this service?",
    a: "Yes — Gold Canyon, Queen Valley, and all Pinal County communities are within our service area. Since we operate entirely by mail, your physical location does not affect processing speed. Ship your documents overnight from the Gold Canyon area, and we handle the rest. Most clients in the Apache Junction metro receive their passports within 2–9 business days.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Apache Junction travelers start online and ship their documents via overnight courier from a local UPS or FedEx location. There is no local Fast Passport Center office in Apache Junction, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function ApacheJunctionFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Apache Junction and Pinal County travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}